<template>
  <div>
    <!-- HMI CONTROLS -->
    <template v-if="!$store.state.productionProfileActive">
      <span class="btn-round-text">
        <v-btn
          :disabled="$store.state.activeErrors.length === 0"
          fab
          x-large
          @click="hmiAction('reset')"
        >
          <v-icon>clear</v-icon>
        </v-btn>
        <span>{{ $t("global.reset") }}</span>
      </span>
    </template>
    <router-link
      v-if="!$store.getters.getUser"
      tag="span"
      to="/application/signIn"
    >
      <span class="btn-round-text" @click="closeOverlay()">
        <v-btn fab x-large>
          <v-icon>mdi-login</v-icon>
        </v-btn>
        <span>{{ $t("global.menu.login") }}</span>
      </span>
    </router-link>
    <router-link
      v-if="$store.getters.getUser"
      tag="span"
      to="/application/signOut"
    >
      <span class="btn-round-text" @click="closeOverlay()">
        <v-btn fab x-large>
          <v-icon>power_settings_new</v-icon>
        </v-btn>
        <span>{{ $t("global.menu.logout") }}</span>
      </span>
    </router-link>
    <!-- PRIMARY NAV BUTTONS -->
    <v-divider></v-divider>
    <router-link v-if="$store.getters.getUser" tag="span" to="/">
      <span class="btn-round-text" @click="closeOverlay()">
        <v-btn fab x-large>
          <v-icon>dashboard</v-icon>
        </v-btn>
        <span>{{ $t("global.menu.clients") }}</span>
      </span>
    </router-link>
    <router-link v-if="$store.getters.getUser" tag="span"
                 to="/users">
      <span class="btn-round-text" @click="closeOverlay()">
        <v-btn fab x-large>
          <v-icon>mdi-account-multiple</v-icon>
        </v-btn>
        <span>{{ $t("global.menu.users") }}</span>
      </span>
    </router-link>
    <router-link tag="span" to="/info">
      <span class="btn-round-text" @click="closeOverlay()">
        <v-btn fab x-large>
          <v-icon>info</v-icon>
        </v-btn>
        <span>{{ $t("global.menu.info") }}</span>
      </span>
    </router-link>

    <!-- Admin environment -->
    <template>
      <!-- DIAGNOSTICS -->
      <v-divider></v-divider>
      <router-link v-if="$store.getters.getUser" tag="span" to="/log-viewer">
        <span class="btn-round-text" @click="closeOverlay()">
          <v-btn fab x-large>
            <v-icon>description</v-icon>
          </v-btn>
          <span>{{ $t("global.menu.logs") }}</span>
        </span>
      </router-link>
    </template>
  </div>
</template>


<script>
import {EVENTBUS_TOPICS, STOMP_TOPICS} from "@/lib/constants";
import {AXIOS} from "@/lib/http-common";
import {EventBus} from "@/lib/event-bus";
import {UserRoleWithPrefix} from "@/components/users/model/UserRoleWithPrefix";

export default {
  name: "navigation-items",
  computed: {
    UserRoleWithPrefix() {
      return UserRoleWithPrefix;
    }
  },
  components: {},
  data() {
    return {
      ivModeSub: null,
      ivMode: null,
    };
  },
  methods: {
    websocketConnected(state) {
      if (state) {
        this.ivModeSub = this.$store.state.stompClient.subscribe(
          STOMP_TOPICS.IV_MODE,
          (message) => {
            this.ivMode = JSON.parse(message.body);
          }
        );
      }
    },
    hmiAction(action) {
      AXIOS.get("/hmi-action/" + action).catch((e) => {
        this.errors.push(e);
      });
    },
    closeOverlay() {
      EventBus.$emit(EVENTBUS_TOPICS.SHOW_OVERLAY, false);
    },
  },
  mounted() {
    EventBus.$on(EVENTBUS_TOPICS.WEBSOCKET_CONNECTED, this.websocketConnected);
    this.websocketConnected(this.$store.state.stompClient.connected);
  },
  beforeDestroy() {
    EventBus.$off(EVENTBUS_TOPICS.WEBSOCKET_CONNECTED, this.websocketConnected);

    if (this.ivModeSub !== null) {
      this.ivModeSub.unsubscribe();
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.current-menu-item button {
  color: $inther-orange;
}
</style>
